<template>
  <div>
    <section style="min-width: 1023px;">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;border:1px solid #dfe6ec;">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-select v-model="value" placeholder="请选择" style="margin-top:2px" @change="changeSouch" >
            <el-option v-for="item in options" :key="item.value"  
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-form-item>
            <el-input v-show="disSouch" v-model="proName" style="width:200px;"  @keyup.enter.native="getList(1)"></el-input>
            <el-select v-show="disType" v-model="typeValue" placeholder="请选择" style="width:200px;" clearable >
              <el-option v-for="item in types" :key="item.value" 
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-show="disAccountType" v-model="accountType" placeholder="请选择" style="width:200px;" clearable >
              <el-option v-for="item in accountTypes" :key="item.value" 
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker v-show="disTime1" style="width:200px;"  v-model="souchs.application_time" format="yyyy-MM-dd" 
                value-format="yyyy-MM-dd" type="date" placeholder="申请日期"> 
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="getList(1)" size="small">查询</el-button>
          </el-form-item>

          <el-form-item>
            <el-button type="text" v-on:click="exportExlsx()" size="small">批量导出</el-button>
          </el-form-item>

        </el-form>
        <el-tag :key="tag" v-for="tag in dynamicTags" closable 
          :disable-transitions="false" @close="handleClose(tag)"> 
            {{tag}} 
        </el-tag>
        <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button>
      </el-col>

      <!--列表-->
      <el-table :data="dataList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" 
        style="width: 100%;" :header-cell-style="getRowClass"  @sort-change="handleSortChange">
        <el-table-column type="index" :index="indexMethod" label="序号" width="80">
          <template slot-scope="scope">
              <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="account" label="手机号"   show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="user_name" label="姓名"   show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="org_name" label="企业"   show-overflow-tooltip>
        </el-table-column>        
        <el-table-column prop="activity_name" label="兑换礼品"   show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="exchange_count" label="兑换数量"   show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="application_time" min-width="120" label="申请日期"  sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" min-width="180" style="text-algin:center">
          <template slot-scope="scope">
            <el-button  type="primary" v-if="scope.row.status == 0" plain size="small" @click="handleDel(scope.$index, scope.row,1)">通过</el-button>
            <el-button  type="danger" v-if="scope.row.status == 0" plain size="small" @click="handleDel(scope.$index, scope.row,2)">驳回申请</el-button>
            <span v-if="scope.row.status == 1"  >已通过</span>
            <span v-if="scope.row.status == 2"  style="color:#F66B3D">已驳回申请</span>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="border:1px solid #dfe6ec;margin-top:0;">
        <el-pagination background 
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50,100]"
          :current-page="pageNumber" 
          :page-size="pageSize" 
          :total="total" 
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          style="float:right;">
        </el-pagination>
      </el-col>
    </section>
    <div class="ftBox">
      <div class="ft">
        <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906</p>
      </div>
    </div>
  </div>
</template>
<script>
import { API__code, API_Integral} from '../../api/index.js'
export default {
  data(){
    return {
      downHref:'',
      disSouch:true,
      disType:false,
      disAccountType:false,
      disTime1:false,
      disTime2:false,
      token:'',
      checkCode:"",
      id:"",
      listLoading:false,
      dataList:[],
      souchs:{
        application_time:''
      },
      
      proName:'',
      pageNumber:1,
      pageSize:10,
      total:0,
      options: [
        {value: '姓名',label: '姓名'}, 
        {value: '手机号',label: '手机号'},
        {value: '企业',label: '企业'},
        {value: '状态',label: '状态'},
        // {value: '订单',label: '订单'},
        // {value: '操作人',label: '操作人'},
        // {value: '价格',label: '价格'},
        {value: '申请日期',label: '申请日期'},
        // {value: '结束日期',label: '结束日期'},
      ],
      value: '',
      types:[
        {value: '0',label: '申请中'},
        {value: '1',label: '通过'},
        {value: '2',label: '驳回'},
        // {value: '3',label: '续费'}
      ],
      accountType:'',
      accountTypes:[
        {value: '0',label: '个人订单'},
        {value: '1',label: '企业订单'},
      ],
      typeValue:'',
      dynamicTags: [],
      orderStr:"application_time",
      orderType:'desc',
    }
  },
  methods:{
    handleSortChange:function(val){
      if(val){
        this.orderStr = val.prop;
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch:function(val){
        this.disAccountType = false;
        this.disSouch = false;
        this.disType = false;
        this.disTime1 = false;
        this.disTime2 = false;
      if(val == "状态"){
        this.typeValue = this.souchs.status;
        this.disType = true;
      }else if(val == "姓名"){
        this.proName = this.souchs.user_name;
        this.disSouch = true;
      }else if(val == "企业"){
        this.proName = this.souchs.org_name;
        this.disSouch = true;
      }else if(val == "手机号"){
        this.proName = this.souchs.account;
        this.disSouch = true;
      }else if(val == "申请日期"){
        //this.souchs.fromtime = this.souchs.application_time;
        this.disTime1 = true;
      }
    },
    getList:function(val){
      if(val == 1){
        this.pageNumber = 1;
      }
      if(this.value == "手机号"){
        this.souchs.account = this.proName;
      }
      if(this.value == "姓名"){
        this.souchs.user_name = this.proName;
      }
      if(this.value == "企业"){
        this.souchs.org_name = this.proName;
      }
      if(this.value == "状态"){
        this.souchs.status = this.typeValue;
      }
      
      
      var flag = true;
      if(val == 1){
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        
        status:this.souchs.status,
        user_name:this.souchs.user_name,
        org_name:this.souchs.org_name,
        account:this.souchs.account,
        application_time:this.souchs.application_time,
        
        orderType: this.orderType,
        orderStr: this.orderStr,
        
      }
      this.listLoading = true;
      API_Integral.getListPage(param)
      .then((res)=>{
        if(res.data.code == API__code.SUCCESS){
          this.dataList = res.data.data.list;
          this.total = res.data.data.totalRow;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },
    delTags:function(){
      this.souchs = {},
      this.souchs.souType = '';
      this.value = '';
      this.typeValue = '';
      this.accountType = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose(tag) {
      if(tag == "状态"){
        this.souchs.status ="";
        this.typeValue = '';
      }
      if(tag == "姓名"){
        this.souchs.user_name="";
        if(this.value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "企业"){
        this.souchs.org_name="";
        if(this.value == "企业"){
          this.proName = '';
        }
      }
      if(tag == "手机号"){
        this.souchs.account ="";
        if(this.value == "手机号"){
          this.proName = '';
        }
      }
      
      if(tag == "开始日期"){
        this.souchs.application_time ="";
      }

      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    handleDel:function(index,row,type){
      
      var title = type == 1 ? '确认通过吗?' : '确认驳回吗?';

      this.$confirm(title, '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          id:row.id,
          status:type
        }
        API_Integral.updateStatus(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        })
      }).catch(err =>{
      });
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*this.pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == 0) {
            return "background:#F5F7FA";
        } else {
            return "";
        }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == 'dnnyptadmin_token') {
                this.token = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                this.checkCode = arr2[1];
            } else if (arr2[0] == 'dnnyptadmin_id') {
                this.id = arr2[1];
            }
        }
      }
    },
    exportExlsx(){
      const link = document.createElement('a');
      const body = document.querySelector('body');

      var href = API_Integral.exportWbs()+"?token="+this.token+"&checkCode="
      +this.checkCode+"&status="+(this.souchs.status || '')+"&user_name="
      +(this.souchs.user_name || '')+"&org_name="+(this.souchs.org_name || '')+"&account="
      +(this.souchs.account || '')+"&application_time="+(this.souchs.application_time || '')+"&orderStr="
      +(this.orderStr || '')+"&orderType="+(this.orderType || '')
    
      link.href = href;

      link.download = '积分兑换导出';
          // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
    }
  },
  mounted(){
    
  },
  created(){
    this.getCookie();
    if(this.$route.query.type == 1){
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber= JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  },

}

// String.prototype.getAns = function() {
//   var pattern = /(?=((?!\b)\d{3})+$)/g;
//   return this.replace(pattern, ',');
// }
</script>
<style scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// exchange.vue?8ef61614